<script>
import { mapStores } from 'pinia'

import { useCartStore } from '@/cart/stores/cart'
import CartFooter from '@/cart/components/CartFooter.vue'
import api from '@/cartapi.js'

export default {
  name: 'LinkTreeApp',

  components: {
    CartFooter,
  },

  data() {
    return {
      commSettings: null,
      showPolicyModal: false,
      policyTitle: '',
      policyContent: '',
    }
  },

  computed: {
    ...mapStores(useCartStore),

    vendor() {
      return this.cartStore?.vendor
    },

    vendorSlug() {
      const host = window.location.hostname || ''
      const parts = host.split('.')
      return parts[0] || ''
    },
  },

  created() {
    console.log('Creating LinkTreeApp', this.vendorSlug)
    api.vendors
      .get(this.vendorSlug)
      .then((vendor) => {
        this.cartStore.setVendor(vendor)
        this.commSettings = vendor.commDefaults || {}
        console.log('Loaded vendor', vendor)
      })
      .catch((err) => {
        console.warn('Failed to load vendor', err)
      })
  },

  methods: {
    handleViewPolicy({ title, content }) {
      this.policyTitle = title
      this.policyContent = content
      this.showPolicyModal = true
    },
  },
}
</script>

<template>
  <div class="linktree-app">
    <div class="main-content">
      <router-view />
    </div>

    <CartFooter v-if="vendor" :vendor="vendor" :settings="commSettings" @view-policy="handleViewPolicy" />

    <!-- Policy Modal (for text-based policies) -->
    <b-modal v-model="showPolicyModal" has-modal-card scroll="keep">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ policyTitle }}</p>
          <button class="delete" aria-label="close" @click="showPolicyModal = false" />
        </header>
        <section class="modal-card-body">
          <div class="content" style="white-space: pre-wrap">{{ policyContent }}</div>
        </section>
        <footer class="modal-card-foot">
          <b-button @click="showPolicyModal = false">Close</b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
@import '@mdi/font/css/materialdesignicons.css';
</style>

<style scoped>
.linktree-app {
  min-height: 100vh;
}

.main-content {
  flex: 1;
}
</style>
